import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Cookies from 'js-cookie'
import SVG from 'react-inlinesvg'
import icon from '@icons/notice/light-blue'
import times from '@icons/times/blue'
import classnames from 'classnames'

class Announcement extends Component {
  constructor(props) {
    super(props)
    this.markRead = this.markRead.bind(this)
    this.state = { show: !this.isRead }
  }

  get keyName() { return this.props.keyName }

  get isRead() {
    return !!Cookies.get(this.keyName)
  }

  markRead(e) {
    Cookies.set(this.keyName, 1, { expires: 365 * 20 })
    this.setState(() => { return { show: false } })
  }

  render() {
    if (!this.state.show) { return null }

    const { className } = this.props
    const classes = classnames('announcement', className)

    return (
      <div className={classes}>
        <SVG className="announcement__icon" src={icon} />
        <div className="announcement__content">{ this.props.children }</div>
        <a href="javascript:void(0)"
           className="announcement__times"
           onClick={this.markRead}
           title={ I18n.t('browser_not_supported.close') }>

          <SVG src={times} />
        </a>
      </div>
    )
  }
}

Announcement.propTypes = {
  keyName: PropTypes.string.isRequired
}

export default Announcement
